<div class="legal-page">
  <div class="legal-hero">
    <div class="legal-hero__bg"></div>
    <div class="legal-hero__content">
      <a class="legal-hero__back" routerLink="/home">
        <i class="fas fa-arrow-left"></i> Retour a l'accueil
      </a>
      <div class="legal-hero__icon"><i class="fas fa-file-contract"></i></div>
      <h1>Conditions Generales de Vente</h1>
      <p class="legal-hero__subtitle">Modalites regissant les abonnements et services payants de la plateforme BeeKids</p>
    </div>
  </div>

  <div class="legal-body">
    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-info-circle"></i></div>
        <h2>1. Preambule</h2>
      </div>
      <div class="legal-card__body">
        <p>Les presentes Conditions Generales de Vente (ci-apres "CGV") regissent les relations contractuelles entre STE DIGITAL POWR CONSULTING, societe de droit tunisien, matricule fiscal 1324048Y, ID Commercant Flouci 5322, ci-apres designee "l'Editeur", et toute personne physique ou morale souhaitant souscrire aux services payants de la plateforme BeeKids, ci-apres designee "l'Abonne".</p>
        <p>L'Abonne declare avoir pris connaissance et accepte les presentes CGV avant toute souscription a un abonnement payant. Le fait de souscrire a un abonnement emporte acceptation pleine et entiere des presentes CGV.</p>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-book-open"></i></div>
        <h2>2. Definitions</h2>
      </div>
      <div class="legal-card__body">
        <ul class="legal-list">
          <li><i class="fas fa-circle"></i> <strong>Plateforme :</strong> L'application web et mobile BeeKids permettant la gestion des etablissements d'education et de garde d'enfants.</li>
          <li><i class="fas fa-circle"></i> <strong>Abonnement :</strong> Service payant donnant acces aux fonctionnalites avancees de la Plateforme pendant une duree determinee.</li>
          <li><i class="fas fa-circle"></i> <strong>Abonne :</strong> Utilisateur ayant souscrit a un Abonnement.</li>
          <li><i class="fas fa-circle"></i> <strong>Trial :</strong> Periode d'essai gratuite offerte a l'Abonne avant la souscription a un Abonnement payant.</li>
          <li><i class="fas fa-circle"></i> <strong>Editeur :</strong> STE DIGITAL POWR CONSULTING, editeur de la Plateforme.</li>
        </ul>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-bullseye"></i></div>
        <h2>3. Objet</h2>
      </div>
      <div class="legal-card__body">
        <p>Les presentes CGV ont pour objet de definir les conditions dans lesquelles l'Editeur fournit a l'Abonne les services payants accessible via la Plateforme BeeKids, ainsi que les modalites de souscription, de paiement, d'utilisation et de resiliation de l'Abonnement.</p>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-concierge-bell"></i></div>
        <h2>4. Description des services</h2>
      </div>
      <div class="legal-card__body">
        <p>La Plateforme BeeKids propose aux etablissements d'education et aux parents les services suivants :</p>
        <ul class="legal-list">
          <li><i class="fas fa-check-circle"></i> Gestion administrative des etablissements (eleves, formateurs, classes)</li>
          <li><i class="fas fa-check-circle"></i> Suivi pedagogique individualise des enfants</li>
          <li><i class="fas fa-check-circle"></i> Gestion des presences, menus et evenements</li>
          <li><i class="fas fa-check-circle"></i> Messagerie interne entre parents et educateurs</li>
          <li><i class="fas fa-check-circle"></i> Paiement des frais de scolarite en ligne</li>
          <li><i class="fas fa-check-circle"></i> Notifications et communications en temps reel</li>
          <li><i class="fas fa-check-circle"></i> Tableaux de bord et statistiques</li>
        </ul>
        <p>Les fonctionnalites detaillees sont accessibles sur le site internet de la Plateforme et peuvent evoluer dans le temps.</p>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-file-signature"></i></div>
        <h2>5. Modalites de souscription</h2>
      </div>
      <div class="legal-card__body">
        <p>La souscription a un Abonnement s'effectue exclusivement en ligne via la Plateforme, selon les modalites suivantes :</p>
        <ul class="legal-list">
          <li><i class="fas fa-check-circle"></i> L'Abonne cree un compte sur la Plateforme en fournissant des informations exactes et completes.</li>
          <li><i class="fas fa-check-circle"></i> Un Trial gratuit de 30 jours est offert a tout nouvel Abonne.</li>
          <li><i class="fas fa-check-circle"></i> Avant l'expiration du Trial, l'Abonne est invite a souscrire a un Abonnement payant pour continuer a beneficier des services.</li>
          <li><i class="fas fa-check-circle"></i> La souscription definitivement engagee a compter de la validation du paiement par l'Editeur.</li>
        </ul>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-credit-card"></i></div>
        <h2>6. Tarifs et modalites de paiement</h2>
      </div>
      <div class="legal-card__body">
        <p><strong>Tarifs :</strong> Le prix de l'Abonnement est de 60 DT (soixante dinars tunisiens) par enfant et par an, hors taxes applicables. Le montant total est calcule en fonction du nombre d'enfants inscrits par l'Abonne.</p>
        <p><strong>Moyens de paiement :</strong> L'Abonne peut regler son Abonnement par l'un des moyens suivants :</p>
        <ul class="legal-list">
          <li><i class="fas fa-credit-card"></i> <strong>Paiement en ligne (Flouci) :</strong> Carte bancaire via la passerelle de paiement Flouci. Le paiement est securise et le montant est debite immediatement.</li>
          <li><i class="fas fa-money-check"></i> <strong>Poste Tunisienne :</strong> Virement ou depot sur le compte CCP de l'Editeur. Le justificatif de paiement doit etre televerse sur la Plateforme.</li>
          <li><i class="fas fa-university"></i> <strong>Virement Bancaire :</strong> Virement sur le compte bancaire de l'Editeur. Le justificatif de virement doit etre televerse sur la Plateforme.</li>
        </ul>
        <p><strong>Validation :</strong> Pour les paiements par Flouci, la validation est automatique et immediate. Pour les paiements par Poste Tunisienne ou Virement Bancaire, la validation est effectuee par l'Editeur apres verification du justificatif, sous 48 heures ouvre es.</p>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-undo"></i></div>
        <h2>7. Conditions de retour, d'echange et de remboursement</h2>
      </div>
      <div class="legal-card__body">
        <p><strong>Droit de retractation :</strong> Conformement a la legislation tunisienne, l'Abonne dispose d'un delai de 7 jours a compter de la validation du paiement pour exercer son droit de retractation et demander le remboursement integral de son Abonnement, a condition de ne pas avoir utilise les services payants.</p>
        <p><strong>Remboursement :</strong> En cas d'exercice du droit de retractation, le remboursement est effectue sous 14 jours ouvre s par le meme moyen de paiement que celui utilise lors de la souscription. Aucun remboursement partiel n'est accorde pour les periodes d'Abonnement deja entamees.</p>
        <p><strong>Echange :</strong> Les abonnements souscrits ne peuvent pas faire l'objet d'un echange. En cas d'erreur de souscription, l'Abonne doit contacter le service client dans un delai de 48 heures.</p>
        <p><strong>Exceptions :</strong> Aucun remboursement n'est accorde en cas de violation des presentes CGV, d'utilisation abusive de la Plateforme ou de fraude constatee.</p>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-ban"></i></div>
        <h2>8. Politique d'annulation</h2>
      </div>
      <div class="legal-card__body">
        <p><strong>Annulation par l'Abonne :</strong> L'Abonne peut annuler son Abonnement a tout moment depuis son espace personnel. L'annulation prend effet a l'expiration de la periode d'Abonnement en cours. Aucun remboursement proportionnel n'est effectue pour la periode restante.</p>
        <p><strong>Annulation par l'Editeur :</strong> L'Editeur se reserve le droit d'annuler ou de suspendre un Abonnement en cas de :</p>
        <ul class="legal-list">
          <li><i class="fas fa-circle"></i> Non-paiement du montant de l'Abonnement</li>
          <li><i class="fas fa-circle"></i> Violation des conditions d'utilisation de la Plateforme</li>
          <li><i class="fas fa-circle"></i> Utilisation frauduleuse ou abusive de la Plateforme</li>
          <li><i class="fas fa-circle"></i> Fourniture d'informations inexactes ou incompletes</li>
        </ul>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-truck"></i></div>
        <h2>9. Modalites de livraison (acces aux services)</h2>
      </div>
      <div class="legal-card__body">
        <p><strong>Acces aux services :</strong> Des la validation du paiement de l'Abonnement, l'Abonne obtient un acces immediat et illimite a l'ensemble des fonctionnalites payantes de la Plateforme pendant la duree de l'Abonnement.</p>
        <p><strong>Duree :</strong> L'Abonnement est souscrit pour une duree d'un (1) an a compter de la date de validation du paiement. Le renouvellement est effectue manuellement par l'Abonne avant l'expiration de la periode en cours.</p>
        <p><strong>Disponibilite :</strong> L'Editeur s'efforce d'assurer une disponibilite de la Plateforme 24h/24 et 7j/7, sous reserve des operations de maintenance necessaires. L'Editeur ne saurait etre tenu responsable des indisponibilites liees a des causes externes (reseau, hebergement, force majeure).</p>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-gavel"></i></div>
        <h2>10. Procedure de resolution des litiges</h2>
      </div>
      <div class="legal-card__body">
        <p>En cas de litige relatif a l'interpretation ou a l'execution des presentes CGV, les parties s'engagent a rechercher une solution amiable avant toute action contentieuse.</p>
        <p><strong>Procedure :</strong></p>
        <ul class="legal-list">
          <li><i class="fas fa-circle"></i> L'Abonne adresse une reclamation ecrite au service client de l'Editeur a l'adresse email : legal&#64;beekids.tn</li>
          <li><i class="fas fa-circle"></i> L'Editeur s'engage a accuser reception de la reclamation sous 48 heures et a y repondre sous 15 jours ouvre s maximum.</li>
          <li><i class="fas fa-circle"></i> Si aucun accord amiable n'est trouve, les parties peuvent recourir a un mediateur agree.</li>
          <li><i class="fas fa-circle"></i> A defaut de resolution amiable, le litige sera soumis aux tribunaux competents de Tunis, Tunisie.</li>
        </ul>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-scale-balanced"></i></div>
        <h2>11. Droit applicable</h2>
      </div>
      <div class="legal-card__body">
        <p>Les presentes CGV sont regies par le droit tunisien. Tout litige relatif a leur interpretation ou a leur execution sera de la competence exclusive des tribunaux de Tunis, Tunisie.</p>
        <p>La langue des presentes CGV est le francais. En cas de traduction dans une autre langue, seule la version francaise fait foi.</p>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-lock"></i></div>
        <h2>12. Protection des donnees personnelles</h2>
      </div>
      <div class="legal-card__body">
        <p>Dans le cadre de l'execution des presentes CGV, l'Editeur collecte et traite les donnees personnelles de l'Abonne conformement a la <a routerLink="/confidentialite">Politique de Confidentialite</a> et a la reglementation applicable (RGPD et loi tunisienne 2018-50).</p>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-phone"></i></div>
        <h2>13. Contact et service client</h2>
      </div>
      <div class="legal-card__body">
        <p>Pour toute question relative aux presentes CGV ou a votre Abonnement, vous pouvez contacter :</p>
        <div class="legal-info-grid">
          <div class="legal-info-item">
            <span class="legal-info-item__label">Email</span>
            <span class="legal-info-item__value">contact&#64;beekids.tn</span>
          </div>
          <div class="legal-info-item">
            <span class="legal-info-item__label">Telephone</span>
            <span class="legal-info-item__value">+216 29 370 239</span>
          </div>
          <div class="legal-info-item">
            <span class="legal-info-item__label">Adresse</span>
            <span class="legal-info-item__value">Tunis, Tunisie</span>
          </div>
        </div>
        <a class="legal-card__cta" href="mailto:contact@beekids.tn">
          <i class="fas fa-envelope"></i> Nous contacter
        </a>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-calendar-alt"></i></div>
        <h2>14. Date d'effet et modifications</h2>
      </div>
      <div class="legal-card__body">
        <p>Les presentes CGV entrent en vigueur a compter de leur publication sur la Plateforme. L'Editeur se reserve le droit de modifier les presentes CGV a tout moment. Les modifications seront notifiees a l'Abonne par email et/ou par notification sur la Plateforme. En cas de refus des modifications, l'Abonne peut resilier son Abonnement dans un delai de 30 jours.</p>
      </div>
    </div>
  </div>
</div>
